import React from "react";

const HookIcon = ({ width, height }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 44 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 16.3062L11.822 28.4116L40 0"
      transform="translate(2 2)"
      stroke="#38C172"
      strokeWidth="3"
    />
  </svg>
);

export default HookIcon;



// WEBPACK FOOTER //
// ../shop_main/images/hookIcon.js